export default __webpack_public_path__ + "static/media/hero-avatar-3.32d96762.jpg";